import * as React from 'react'
import '../../styles/pages.css'
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import AddLMSConfiguration from './admin_components/AddLMSConfiguration'
import DeleteExpiredDemo from './admin_components/DeleteExpiredDemo'

const AdminTools = () => {
  return (
    <div>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          Enter New LTI LMS Configuration
        </AccordionSummary>
        <AccordionDetails>
          <AddLMSConfiguration />
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          Soft-Delete Expired Demos
        </AccordionSummary>
        <AccordionDetails>
          <DeleteExpiredDemo />
        </AccordionDetails>
      </Accordion>
    </div>
  )
}

export default AdminTools
